export default function ({ redirect }) {
  if (process.env.SUBDOMAIN === "customer") {
    redirect("/search")
  }
}
